import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { history, store } from '../../helpers/index';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';
import CurrencyInput from '../currencyinput/CurrencyInput';
import getSymbolFromCurrency from 'currency-symbol-map';
import { projectActions } from '../../actions';
import Strings from '../../common/Strings';
import './EditProjectMemberDialog.css';

class EditProjectMemberDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clickedButton: 0,
      hourlyRate: props.teamMember.hourlyRate,
    };
  }

  onRateChanged = (event, maskedValue, floatValue) => {
    this.setState({ hourlyRate: floatValue });
  };

  doUpdateRate(project, teamMember, hourlyRate) {
    const { teamMembers } = project;
    const objIndex = teamMembers.findIndex(t => t.uid === teamMember.uid);
    const updatedObj = { ...teamMembers[objIndex], hourlyRate };

    project.teamMembers = [
      ...teamMembers.slice(0, objIndex),
      updatedObj,
      ...teamMembers.slice(objIndex + 1),
    ];
  }

  onClickRestoreDefault = (project, teamMember) => {
    const rate = store
      .getState()
      .teamMembers.find(t => t.uid === teamMember.uid).hourlyRate;
    this.doUpdateRate(project, teamMember, rate);
    this.props.dispatch(projectActions.updateProject(project));
    this.setState({ clickedButton: 0 });
  };

  onClickUpdate = (project, teamMember) => {
    this.doUpdateRate(project, teamMember, this.state.hourlyRate);
    this.props.dispatch(projectActions.updateProject(project));
    this.setState({ clickedButton: 1 });
  };

  render() {
    const project = { ...this.props.project };
    const teamMember = { ...this.props.teamMember };
    const { isCreatingOrUpdatingProject } = this.props;
    const { clickedButton, hourlyRate } = this.state;
    return (
      <Modal
        centered
        open
        size="tiny"
        closeIcon={!isCreatingOrUpdatingProject}
        onClose={() => history.goBack()}
      >
        <div className="edit-project-member-modal-root">
          <div className="edit-project-member-top-container">
            <p className="edit-project-member-title">
              {Strings.PROJECT_DETAILS.editMemberDialogTitle}
            </p>
          </div>
          <div className="edit-project-member-content">
            <p className="edit-project-member-info">
              {Strings.PROJECT_DETAILS.editMemberDialogInfo}
            </p>
            <p className="edit-project-member-rate-title">
              {Strings.PROJECT_DETAILS.editMemberDialogRateTitle}
            </p>
            <div className="edit-project-member-rate-container">
              <p className="edit-project-member-rate-currency">
                {getSymbolFromCurrency(this.props.defaultCurrency)}
              </p>
              <CurrencyInput
                id="edit-project-member-rate-input"
                value={hourlyRate}
                onChangeEvent={this.onRateChanged}
              />
              <p className="edit-project-member-rate-per-hr">
                {Strings.COMMON.perHour}
              </p>
            </div>
            <div style={{ display: 'flex' }}>
              <Button
                id="edit-project-member-restore-default-button"
                className="common-grey-button"
                style={{ minWidth: 150 }}
                disabled={isCreatingOrUpdatingProject}
                loading={isCreatingOrUpdatingProject && clickedButton === 0}
                onClick={() => this.onClickRestoreDefault(project, teamMember)}
              >
                {Strings.PROJECT_DETAILS.restoreDefault}
              </Button>
              <div style={{ width: 10 }} />
              <Button
                id="edit-project-member-update-button"
                className="common-green-button"
                style={{ minWidth: 150 }}
                disabled={isCreatingOrUpdatingProject}
                loading={isCreatingOrUpdatingProject && clickedButton === 1}
                onClick={() => this.onClickUpdate(project, teamMember)}
              >
                {Strings.COMMON.update}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

EditProjectMemberDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({}).isRequired,
  teamMember: PropTypes.shape({
    uid: PropTypes.string.isRequired,
  }).isRequired,
  defaultCurrency: PropTypes.string,
};

const mapStateToProps = state => ({
  isCreatingOrUpdatingProject: state.uiState.isCreatingOrUpdatingProject,
  defaultCurrency: state.user.defaultCurrency,
});

export default connect(mapStateToProps)(EditProjectMemberDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/EditProjectMemberDialog.js